export const PendingListData = [
   {
    disputeId: "DSP-001",
     id: 1,
    complainantName: "Ramesh Shrestha",
    respondentName: "Everest Traders Pvt. Ltd.",
    disputeType: "Payment Delay",
    branch: "Kathmandu",
    filedDate: "2025-10-12",
    lastUpdated: "2025-11-04",
    status: "Pending Review",
    assignedTo: "Sita Gurung",
    priority: "High",
    description: "Payment for invoice #INV-3921 has been delayed for over 45 days.",
    documentsAttached: 2
  },
  {
    disputeId: "DSP-002",
     id: 2,
    complainantName: "Maya Thapa",
    respondentName: "Himalayan Logistics",
    disputeType: "Damaged Goods",
    branch: "Pokhara",
    filedDate: "2025-09-28",
    lastUpdated: "2025-10-25",
    status: "Pending Verification",
    assignedTo: "Rabin Lama",
    priority: "Medium",
    description: "Goods were received in damaged condition during transit.",
    documentsAttached: 3
  },
  {
    disputeId: "DSP-003",
     id: 3,
    complainantName: "Sanjay Basnet",
    respondentName: "Nepal Telecom",
    disputeType: "Service Interruption",
    branch: "Biratnagar",
    filedDate: "2025-11-01",
    lastUpdated: "2025-11-05",
    status: "Pending Resolution",
    assignedTo: "Nisha Karki",
    priority: "High",
    description: "Internet service has been interrupted for more than 72 hours.",
    documentsAttached: 1
  },
  {
    disputeId: "DSP-004",
     id: 4,
    complainantName: "Bikash KC",
    respondentName: "Sunrise Bank Ltd.",
    disputeType: "Unauthorized Transaction",
    branch: "Lalitpur",
    filedDate: "2025-10-29",
    lastUpdated: "2025-11-03",
    status: "Pending Investigation",
    assignedTo: "Puja Adhikari",
    priority: "Critical",
    description: "Unauthorized transaction of NPR 15,000 detected in account ending 4523.",
    documentsAttached: 4
  },
  {
    disputeId: "DSP-005",
     id: 5,
    complainantName: "Kamal Shrestha",
    respondentName: "Smart Tech Solutions",
    disputeType: "Contract Breach",
    branch: "Chitwan",
    filedDate: "2025-10-15",
    lastUpdated: "2025-11-01",
    status: "Pending Response",
    assignedTo: "Manish Dahal",
    priority: "Low",
    description: "Service contract terms were not honored as per agreement.",
    documentsAttached: 2
  }
]